// Module
var code = "<div class=\"component-editor-execute-sql\">\n  <steps>\n    <step ng-model=\"connectionStep\"></step>\n    <step ng-model=\"componentFormStep\"></step>\n    <step ng-model=\"packageOperatorStep\"></step>\n  </steps>\n</div>\n";
// Exports
module.exports = code;